import * as React from "react";
import { Path, Rect, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const AUIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="AU" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#2E42A5"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <G clipPath="url(#b)">
        <Path fill="#2E42A5" d="M0 0h8.8v7.2H0z" />
        <Path
          fill="#F7FCFF"
          d="m-1.802 6.5 1.98.869L8.245.945 9.29-.346l-2.118-.29-3.29 2.768-2.649 1.865L-1.802 6.5Z"
        />
        <Path
          fill="#F50100"
          d="m-1.531 7.108 1.009.505 9.436-8.08H7.498l-9.029 7.575Z"
        />
        <Path
          fill="#F7FCFF"
          d="M9.202 6.5 7.444 7.616-.845.944-1.89-.346l2.118-.29 3.29 2.768 2.649 1.865L9.202 6.5Z"
        />
        <Path
          fill="#F50100"
          d="m9.135 6.937-1.01.504-4.018-3.46-1.19-.386L-1.99-.342h1.417L4.33 3.502l1.303.463 3.502 2.972Z"
        />
        <Path
          fill="#F50100"
          fillRule="evenodd"
          d="M4 0h-.8v3.2h-4V4h4v3.2H4V4h4v-.8H4V0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M2.45 0h2.3v2.45L8 2.4v2.3l-3.25.05V7.2h-2.3V4.75L-.8 4.7V2.4l3.25.05V0Zm.75 3.2h-4V4h4v3.2H4V4h4v-.8H4V0h-.8v3.2Z"
          clipRule="evenodd"
        />
      </G>
      <G fill="#F7FCFF" clipPath="url(#c)">
        <Path d="m4.736 9.823-.656.606.065-.891-.883-.135.737-.505-.445-.774.854.262.328-.831.328.83.854-.261-.445.774.737.505-.883.135.065.891-.656-.606ZM10.592 6.637l-.437.405.043-.594-.589-.09.492-.337-.297-.516.57.174.218-.554.219.554.57-.174-.298.516.492.337-.589.09.043.594-.437-.405ZM11.616 2.37l-.437.405.043-.594-.589-.09.492-.337-.297-.516.57.175.218-.554.219.554.569-.175-.297.516.492.337-.589.09.043.594-.437-.404ZM14.176 4.504l-.437.404.043-.594-.589-.09.492-.336-.297-.517.57.175.218-.554.219.554.57-.175-.298.517.492.336-.589.09.043.594-.437-.404ZM12.128 10.637l-.437.405.043-.594-.589-.09.492-.337-.297-.516.57.174.218-.554.219.554.57-.174-.298.516.492.337-.589.09.043.594-.437-.405ZM13.92 7.311l-.444.234.084-.495-.36-.35.498-.072.222-.45.222.45.497.072-.36.35.085.495-.444-.234Z" />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
      <ClipPath id="b">
        <Path fill="#fff" d="M0 0h8.8v7.2H0z" />
      </ClipPath>
      <ClipPath id="c">
        <Path fill="#fff" d="M3.2.8h12v10.4h-12z" />
      </ClipPath>
    </Defs>
  </Icon>
);
